const testimonial_el = document.querySelectorAll('[id^="testimonial_slider_"]');

testimonial_el.forEach(el => {
  let testimonial_swiper = new Swiper('#' + el.id + ' .swiper-container', {
    slidesPerView: ( $('#' + el.id + ' .swiper-container' + ' .swiper-slide').length == 1 ) ? 1 : 'auto',
    loop: ( $('#' + el.id + ' .swiper-container' + ' .swiper-slide').length == 1 ) ? false : true,
    pagination: ( $('#' + el.id + ' .swiper-container' + ' .swiper-slide').length > 1 ) ? {
      el: '#' + el.id + ' .swiper-container .swiper-pagination',
      clickable: true
    } : false
  });
});